import { render, staticRenderFns } from "./ProjectsArchivePage.vue?vue&type=template&id=08d4892d&scoped=true&"
import script from "./ProjectsArchivePage.vue?vue&type=script&lang=js&"
export * from "./ProjectsArchivePage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsArchivePage.vue?vue&type=style&index=0&id=08d4892d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d4892d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d4892d')) {
      api.createRecord('08d4892d', component.options)
    } else {
      api.reload('08d4892d', component.options)
    }
    module.hot.accept("./ProjectsArchivePage.vue?vue&type=template&id=08d4892d&scoped=true&", function () {
      api.rerender('08d4892d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/projects/ProjectsArchivePage.vue"
export default component.exports